function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useState } from "react";
import { operationTypes } from "../../constants";
import CreateExchangeDialog from "./CreateExchangeDialog";
export var ExchangeContext = /*#__PURE__*/React.createContext({});
export var ExchangeProvider = function ExchangeProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    investmentItem = _useState2[0],
    setInvestmentItem = _useState2[1];
  var _useState3 = useState({
      type: operationTypes.BUY
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    operation = _useState4[0],
    setOperation = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    successCallback = _useState6[0],
    setSuccessCallback = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    exchangeDialogOpen = _useState8[0],
    setExchangeDialogOpen = _useState8[1];
  var toggleExchangeDialogOpen = function toggleExchangeDialogOpen(investmentItem, operation, successCallback) {
    setInvestmentItem(investmentItem);
    setOperation(operation);
    setSuccessCallback(function () {
      return successCallback;
    });
    setExchangeDialogOpen(!exchangeDialogOpen);
  };
  return /*#__PURE__*/React.createElement(ExchangeContext.Provider, {
    value: {
      exchangeDialogOpen: exchangeDialogOpen,
      toggleExchangeDialogOpen: toggleExchangeDialogOpen
    }
  }, children, exchangeDialogOpen && /*#__PURE__*/React.createElement(CreateExchangeDialog, {
    centered: true,
    open: exchangeDialogOpen,
    onClose: toggleExchangeDialogOpen,
    investmentItem: investmentItem,
    operation: operation,
    successCallback: successCallback
  }));
};
export var useExchangeContext = function useExchangeContext() {
  return useContext(ExchangeContext);
};